import { defineStore } from 'pinia';
import { ref } from 'vue';

import {
  TContractorInfoStore,
  TContractorSiderCountPayload,
  TContractorCanSeeRunIncidentsPayload,
} from '@/stores/contractorInfo/types';

export const useContractorInfoStore = defineStore('TMS_CONTRACTOR_INFO',
  (): TContractorInfoStore => {
    const currentRunsCount = ref<number | null>(null);
    const plannedRunsCount = ref<number | null>(null);
    const finishedRunsCount = ref<number | null>(null);
    const incidentsCount = ref<number | null>(null);
    const canSeeRunIncidents = ref<boolean>(false);

    const setCurrentRunsCount = ({ count }: TContractorSiderCountPayload) => {
      currentRunsCount.value = count;
    };

    const setPlannedRunsCount = ({ count }: TContractorSiderCountPayload) => {
      plannedRunsCount.value = count;
    };

    const setFinishedRunsCount = ({ count }: TContractorSiderCountPayload) => {
      finishedRunsCount.value = count;
    };

    const setIncidentsCount = ({ count }: TContractorSiderCountPayload) => {
      incidentsCount.value = count;
    };

    const setCanSeeRunIncidents = (payload: TContractorCanSeeRunIncidentsPayload) => {
      canSeeRunIncidents.value = payload.canSeeRunIncidents;
    };

    return {
      currentRunsCount,
      plannedRunsCount,
      finishedRunsCount,
      incidentsCount,
      canSeeRunIncidents,

      setCurrentRunsCount,
      setPlannedRunsCount,
      setFinishedRunsCount,
      setIncidentsCount,
      setCanSeeRunIncidents,
    };
  });
